export function buildExecutiveReportConfig(activeWorkflow: string | null, reportData: any, formData: any) {
    const config = reportData || formData || {};
    return {
        ...config,
        analysisType: activeWorkflow === 'composite_analytics'
            ? 'operational_analytics'
            : config.analysisType || 'intelligence_report',
    };
}

export function readExecutiveReportResponse(response: any) {
    if (response?.reportId)
        return { reportId: String(response.reportId), reportData: null };
    if (response?.data && typeof response.data === 'object')
        return { reportId: null, reportData: response.data };
    throw new Error('The report service returned an incomplete response. Please retry.');
}
